<div class="spinnerAndTextContainer">
  <mat-progress-spinner class="" color="accent" mode="indeterminate" diameter="40"></mat-progress-spinner>
  <div class="textContainer">
    <ng-content></ng-content>
  </div>
</div>